import { render, staticRenderFns } from "./HibiValue.vue?vue&type=template&id=12804928&"
import script from "./HibiValue.vue?vue&type=script&lang=ts&"
export * from "./HibiValue.vue?vue&type=script&lang=ts&"
import style0 from "./HibiValue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports